import { FooterResource } from './FooterResource';

export class FooterListResource {
    footerList: FooterResource[];
}